/* eslint-disable no-nested-ternary */
/**
 * 横向滚动hooks
 */
export const useLateralRoll = (ele: HTMLElement) => {
  const el: HTMLElement = ele;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const scroll = (event: any) => {
    if (el.clientWidth >= el.scrollWidth) { return; }
    event.preventDefault();
    el.scrollLeft += event.deltaY
      ? event.deltaY
      : (event.detail && event.detail !== 0)
        ? event.detail
        : -event.wheelDelta;
  };
  const handleWheelEvent = () => {
    const event = 'addEventListener'; // window.addEventListener() ? 'addEventListener' : 'attachEvent';
    let wheel = '';

    if ('onmousewheel' in el) {
      wheel = 'mousewheel';
    } else if ('onwheel' in el) {
      wheel = 'wheel';
    } else if ('attachEvent' in window) {
      wheel = 'onmousewheel';
    } else {
      wheel = 'DOMMouseScroll';
    }
    el[event](wheel, scroll);
  };
  handleWheelEvent();
};

/**
 * 设计思路与构想
 *   version 1.0
 *    传入一个 Ref<Element>
 *    在该 Element 中，滚轮滚动事件将被重置为横向滚动
 *   version 2.0
 *    传入两个 Ref<Element>
 *      源对象 SourceRef
 *      目标对象 TargetRef
 *    通过源对象 控制 目标对象
 *      禁用 源对象 的事件，并将原本的事件效果映射到 目标对象 上
 *    控制方式
 *      也可以不再局限于 滚轮滚动 事件了
 *    为什么这么设计
 *      从version 1.0 看，实现方式为禁用原本的滚动事件，但如果目标对象的子元素也有滚动条，那么就不能滚动查看子元素内容了
 *      那么如果要剥离出触发方式，完全可以通过控制另一个元素实现（源对象）
 *  需要注意的点
 *    - 因为 version 2.0 剥离出了 源对象，但源对象是很有可能没有滚动条的，也就是触发条件要有额外的处理
 *      就滚动来说，可以监听滚动事件(addEventListener-mousewheel)，同时判断鼠标是否在 源对象上(zCompositionHooks)
 */
export const info = '横向滚动hooks';
